import { Component, OnInit, SimpleChanges, AfterViewInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookiesService } from 'src/app/CookieService';
import { AnnualGradeIcons, LatestResultIconsDesktop, LatestResultIconsMobile } from 'src/app/models/app-constants';
import { SiteAnnualgradeTrendModel } from 'src/app/models/SiteDetails/SiteAnnualgradeTrendModel';
import { SiteDetailsModel, SiteTrends, TrendTypes } from 'src/app/models/SiteDetails/SiteDetailsModel';
import { SiteEnterococciTrendModel } from 'src/app/models/SiteDetails/SiteEnterococciTrendModel';
import { SiteRainfallTrendModel } from 'src/app/models/SiteDetails/SiteRainfallTrendModel';
import { SiteWatertempTrendModel } from 'src/app/models/SiteDetails/SiteWatertempTrendModel';
import { SitesDetailsService } from 'src/app/services/sitedetails.service';
import { Observe } from 'src/app/shared/custom-decorators/Observe';
import { Observable, Subscription } from 'rxjs';

@Component({
	selector: 'app-site-details',
	templateUrl: './site-details.component.html',
	styleUrls: ['./site-details.component.scss'],
	providers: [SitesDetailsService]
})

export class SiteDetailsComponent implements OnInit, OnChanges, AfterViewInit {
	//@Input() site : BeachSite;	
	private subscribeHandles: any[] = [];

	private siteIdentifier: string;

	@Observe("siteIdentifier") siteIdentifier$! : Observable<string>;
	private siteIdentifierSub : Subscription;

	public siteDetails: SiteDetailsModel;
	public siteRainfallTrends: SiteRainfallTrendModel[];
	public siteEnterococciTrends: SiteEnterococciTrendModel[];
	public siteAnnualgradeTrends: SiteAnnualgradeTrendModel[];
	public siteWatertempTrends: SiteWatertempTrendModel[];
	public trendTypes = TrendTypes;
    public breadcrumbLocations : { target : string; label : string }[] = [{ target : 'home', label : 'Home'}];

	constructor(private _Activatedroute: ActivatedRoute,
		private _router: Router,
		private siteDetailsService: SitesDetailsService) 
    {

	}

	ngOnInit(): void {
		this.siteIdentifierSub = this.siteIdentifier$?.subscribe({			
			next : (value : string) => {
				if(value)
				{
					//this.getData();
				}
			},
			error : (ex : Error) => {

			},
			complete : () => {

			}
		});
		const handle = this._Activatedroute.paramMap.subscribe((params) => {
			this.siteIdentifier = params.get('id') || "";
			this.siteIdentifier && this.getData();
		});
		this.subscribeHandles.push(handle);
	}

	ngOnChanges(changes: SimpleChanges): void {
		
	}

	ngOnDestroy() {
		for (let i = 0; i < this.subscribeHandles.length; ++i) 
		{
			this.subscribeHandles[i]?.unsubscribe();
		}
		this.subscribeHandles = [];
		this.siteIdentifierSub && this.siteIdentifierSub?.unsubscribe();
	}

	ngAfterViewInit(): void 
	{		

	}

	private getData(): void 
	{
		this.loadSiteDetails();
	}

	private loadSiteDetails(): void 
	{
		this.breadcrumbLocations = [{ target : 'home', label : 'Home'}];
		if (this.siteIdentifier) 
		{
			
			try 
			{	
				const handle = this.siteDetailsService.getSiteDetails(this.siteIdentifier).subscribe(
				{
					next: (data : SiteDetailsModel) => 
                    {
						this.siteDetails = Object.assign(new SiteDetailsModel(), { ...data } as SiteDetailsModel);						
						data.PollForecastDt && (this.siteDetails.PollForecastDt = new Date(Date.parse(data.PollForecastDt?.toString())));
						data.LatestResultDt && (this.siteDetails.LatestResultDt = new Date(Date.parse(data.LatestResultDt?.toString())));
                     		
						if(this.siteDetails?.Region && -1 === this.breadcrumbLocations.findIndex((a) => a.label?.toLocaleLowerCase() === this.siteDetails?.Region?.toLocaleLowerCase()))
						{
							this.breadcrumbLocations.push({target : "", label : this.siteDetails?.Region });
						}						
                        this.loadSiteTrends(this.siteDetails.Identifier, this.siteDetails.Council ?? "",
							this.siteDetails.Region ?? "", this.siteDetails.SiteType ?? "");
					},
					error: (error) => {
						console.log(error);
					},
					complete: () => {
						
					}
				});
				this.subscribeHandles.push(handle);
			}
			catch (ex: any) {
				console.log(ex.message);
			}

		}
	}

	private loadEnterococciTrends = (siteId: string, council = "", region = "", siteType = ""): void => {
		try 
        {			
			const handle = this.siteDetailsService.getSiteEnterococciTrend(siteId, council, region, siteType).subscribe({
				next: (data) => {					
					this.siteEnterococciTrends = Array.isArray(data) ? data.map((a: any) => {
						return new SiteEnterococciTrendModel(new Date(Date.parse(a.MeasurementDt)), a.EntPer100Ml);
					}) : [];					
					
				},
				error: (error) => {
					console.log(error);
				},
				complete: () => {						
				}

			});
			this.subscribeHandles.push(handle);
		}
		catch (ex: any) {
			console.log(ex.message);
		}
	}

	private loadAnnualGrades = (siteId: string, council = "", region = "", siteType = ""): void => {
		try 
        {			
			const handle = this.siteDetailsService.getSiteAnnualgradeTrend(siteId).subscribe(
				{
					next: (data) => {						
						this.siteAnnualgradeTrends = Array.isArray(data) ? data?.map((a: any) => {
							return new SiteAnnualgradeTrendModel(a.Year, a["Annual Grade"]);
						}) : [];
					},
					error: (error) => {
						console.log(error);
					},
					complete: () => {
						
					}
			});
			this.subscribeHandles.push(handle);
		}
		catch (ex: any) {
			console.log(ex.message);
		}
	}

	private loadRainfallData = (siteId: string, council = "", region = "", siteType = ""): void => {
		try 
        {
			const handle = this.siteDetailsService.getSiteRainfallTrend(siteId, council, region, siteType).subscribe(
				{
					next: (data) => {
						this.siteRainfallTrends = Array.isArray(data) ? data.map((a: any) => {
							return new SiteRainfallTrendModel(new Date(Date.parse(a.MeasurementDt)), a.Rainfall24hr);
						}) : [];
					},
					error: (error) => {
						console.log(error);
					},
					complete: () => {
						
					}
				});
			this.subscribeHandles.push(handle);
		}
		catch (ex: any) {
			console.log(ex.message);
		}

	}

	private loadWaterTempData = (siteId: string, council = "", region = "", siteType = ""): void => {
		try 
        {
			const handle = this.siteDetailsService.getSiteWatertempTrend(siteId, council, region, siteType).subscribe(
				{
					next: (data) => {						
						this.siteWatertempTrends = Array.isArray(data) ? data.map((a: any) => {
							return new SiteWatertempTrendModel(new Date(Date.parse(a.MeasurementDt)), a.WaterTemp);
						}) : [];
					},
					error: (error) => {
						console.log(error);
					},
					complete: () => {
						
					}
				});
				this.subscribeHandles.push(handle);
		}
		catch (ex: any) {
			console.log(ex.message);
		}
	}



	private loadSiteTrends(siteId: string, council = "", region = "", siteType = ""): void {
		this.loadAnnualGrades(siteId, council, region, siteType);
		this.loadEnterococciTrends(siteId, council, region, siteType);
		this.loadRainfallData(siteId, council, region, siteType);
		this.loadWaterTempData(siteId, council, region, siteType);
	}


	getAnnualGradeIcon(): string {
		const icon = AnnualGradeIcons.get(this.siteDetails?.AnnualGrade)
		return icon ? <string>icon : "";
	}

	getLatestResultsIcon(mobile = false): string {
		let icon = "";
		switch (this.siteDetails?.LatestResultStarRating) {
			case 1:
				icon = mobile ? LatestResultIconsMobile.get("Bad")! : LatestResultIconsDesktop.get("Bad")!;
				break;
			case 2:
				icon = mobile ? LatestResultIconsMobile.get("Poor")! : LatestResultIconsDesktop.get("Poor")!;
				break;
			case 3:
				icon = mobile ? LatestResultIconsMobile.get("Ok")! : LatestResultIconsDesktop.get("Ok")!;
				break;
			case 4:
				icon = mobile ? LatestResultIconsMobile.get("Good")! : LatestResultIconsDesktop.get("Good")!;
				break;
			default:
				icon = "";
		}

		return icon ? <string>icon : "";
	}

	canDisplayTrendSection = (name :  TrendTypes) => {
		
		//let yesOrNo = true;

		let yesOrNo = false;
		if(Array.isArray(this.siteDetails?.Trends))
		{
			yesOrNo = -1 < this.siteDetails?.Trends?.findIndex((item : SiteTrends) => item?.Name === name);
		}
		
		
		return yesOrNo;
	}   
	
	canDisplayDivider = () => {
		return this.canDisplayTrendSection(this.trendTypes?.Enterococci) || 
			this.canDisplayTrendSection(this.trendTypes?.Rainfall) || 
			!!this.siteDetails?.ShowWaterTemp && this.canDisplayTrendSection(this.trendTypes?.WaterTemp) ||
			this.canDisplayTrendSection(this.trendTypes?.AnnualGrade);			
	}
}
